export default __webpack_public_path__ + "static/media/63.5ff964a3.svg";